import { Util } from '@grandvisionhq/forms';
import { useAdyen } from '@grandvisionhq/payments';
import { useIntl } from '@grandvisionhq/state';

// Some data, like billing address and shipping contact, are only available after the user authorized the payment.
const isEmailValid = (email)=>email && Util.validations.isEmailAddress(email)
;
const isPostalCodeValid = (country, postalCode)=>country && postalCode && Util.validations.isValidPostalCodeForCountry(country, postalCode)
;
const useValidatePaymentData = ()=>{
    var ref1;
    const { getLabel  } = useIntl();
    const { config  } = useAdyen();
    const addressValidations = config === null || config === void 0 ? void 0 : (ref1 = config.applepay) === null || ref1 === void 0 ? void 0 : ref1.addressValidation;
    return (e, session)=>{
        const { shippingContact , billingContact  } = e === null || e === void 0 ? void 0 : e.payment;
        if (!isEmailValid(shippingContact === null || shippingContact === void 0 ? void 0 : shippingContact.emailAddress)) {
            session.completePayment({
                status: ApplePaySession.STATUS_INVALID_SHIPPING_CONTACT,
                errors: [
                    new ApplePayError('shippingContactInvalid', 'emailAddress', getLabel('checkout.contact.email.errorMessage')), 
                ]
            });
            return false;
        }
        if (!isPostalCodeValid(billingContact === null || billingContact === void 0 ? void 0 : billingContact.countryCode, billingContact === null || billingContact === void 0 ? void 0 : billingContact.postalCode)) {
            session.completePayment({
                status: ApplePaySession.STATUS_INVALID_BILLING_POSTAL_ADDRESS,
                errors: [
                    new ApplePayError('billingContactInvalid', 'postalCode', getLabel('checkout.address.postalCode.errorMessage')), 
                ]
            });
            return false;
        }
        if (shippingContact) {
            if (!isPostalCodeValid(shippingContact === null || shippingContact === void 0 ? void 0 : shippingContact.countryCode, shippingContact === null || shippingContact === void 0 ? void 0 : shippingContact.postalCode)) {
                session.completePayment({
                    status: ApplePaySession.STATUS_INVALID_SHIPPING_POSTAL_ADDRESS,
                    errors: [
                        new ApplePayError('shippingContactInvalid', 'postalCode', getLabel('checkout.address.postalCode.errorMessage')), 
                    ]
                });
                return false;
            }
            if ((addressValidations === null || addressValidations === void 0 ? void 0 : addressValidations.firstName) && !(addressValidations === null || addressValidations === void 0 ? void 0 : addressValidations.firstName((shippingContact === null || shippingContact === void 0 ? void 0 : shippingContact.givenName) || ''))) {
                session.completePayment({
                    status: ApplePaySession.STATUS_INVALID_SHIPPING_CONTACT,
                    errors: [
                        new ApplePayError('shippingContactInvalid', 'name', getLabel('checkout.address.firstName.errorMessage')), 
                    ]
                });
                return false;
            }
            if ((addressValidations === null || addressValidations === void 0 ? void 0 : addressValidations.lastName) && !(addressValidations === null || addressValidations === void 0 ? void 0 : addressValidations.lastName((shippingContact === null || shippingContact === void 0 ? void 0 : shippingContact.familyName) || ''))) {
                session.completePayment({
                    status: ApplePaySession.STATUS_INVALID_SHIPPING_CONTACT,
                    errors: [
                        new ApplePayError('shippingContactInvalid', 'name', getLabel('checkout.address.lastName.errorMessage')), 
                    ]
                });
                return false;
            }
            if ((addressValidations === null || addressValidations === void 0 ? void 0 : addressValidations.streetName) && (shippingContact === null || shippingContact === void 0 ? void 0 : shippingContact.addressLines)) {
                const addressLinesValid = shippingContact.addressLines.every((line)=>{
                    var ref;
                    return addressValidations === null || addressValidations === void 0 ? void 0 : (ref = addressValidations.streetName) === null || ref === void 0 ? void 0 : ref.call(addressValidations, line);
                });
                if (!addressLinesValid) {
                    session.completePayment({
                        status: ApplePaySession.STATUS_INVALID_SHIPPING_CONTACT,
                        errors: [
                            new ApplePayError('shippingContactInvalid', 'addressLines', getLabel('checkout.address.streetName.errorMessage')), 
                        ]
                    });
                    return addressLinesValid;
                }
            }
        }
        if (!(billingContact === null || billingContact === void 0 ? void 0 : billingContact.locality)) {
            session.completePayment({
                status: ApplePaySession.STATUS_INVALID_BILLING_POSTAL_ADDRESS,
                errors: [
                    new ApplePayError('billingContactInvalid', 'locality', getLabel('checkout.address.city.errorMessage')), 
                ]
            });
            return false;
        }
        return true;
    };
};

export { useValidatePaymentData };
//# sourceMappingURL=use-validate-payment-data.js.map
